import { PaginatedSamplesQuery } from 'apollo/sample';
import { PaginatedPacksAndRepacksQuery } from 'apollo/packAndRepack/packAndRepack.gql';
import { EventIds } from '../../constants';

const browseQueries = {
    samples: {
        query: PaginatedSamplesQuery,
        pathToItems: 'paginatedSamples',
        pathToTotalItems: 'totalSampleRecords',
        failureEvent: {
            eventId: EventIds.RequestSamplesPageFailed,
            message: 'Browse samples page request failed',
        },
    },
    packs: {
        query: PaginatedPacksAndRepacksQuery,
        pathToItems: 'paginatedPacksAndRepacks',
        pathToTotalItems: 'totalPackRecords',
        failureEvent: {
            eventId: EventIds.RequestPacksPageFailed,
            message: 'Browse packs page request failed',
        },
    },
    repacks: undefined,
};

export default browseQueries;
